/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/journal/2019-11-21.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/journal/2019-11-21.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/2019-11-21.mdx';

const metadata = {
  slug: "2019-11-21",
  title: "Reset",
  author: "Christian Battaglia",
  description: "A reset of downthewhole.com and cdbattaglia.com — plus gratitude, daily link collection, and exploring Rust's async ecosystem with Actix and Artichoke.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2019-11-21T00:00:00.000Z",
  
  readTime: "5 min read",
  tags: ["Rust","Actix","personal website","reset","gratitude","Artichoke","async","web development"],
};

export const Route = createFileRoute('/blog/posts/2019-11-21')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/2019-11-21',
    image: '/og/blog/2019-11-21.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
